import React from 'react';
import { Meeting } from '../../services/meetingService';
import {
  parseWorkshopCalendar,
  formatCalendarDateLabel,
  formatCalendarStepLabel,
  shouldShowWorkshopCalendar,
  calendarHasContent,
} from '../../data/workshopCalendar';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopCalendarMemberViewProps {
  meeting: Meeting | null;
}

function CalendarStatusLine({ label, value }: { label: string; value: string }) {
  return (
    <p className={styles.calendarStatusLine}>
      {label}: <strong>{value}</strong>
    </p>
  );
}

const WorkshopCalendarMemberView: React.FC<WorkshopCalendarMemberViewProps> = ({ meeting }) => {
  const { t } = useLocale();
  const cal = parseWorkshopCalendar(meeting);

  if (!shouldShowWorkshopCalendar(meeting)) {
    return (
      <p className={styles.comingSoonNote}>{t('workshop.2026.calendar.empty_underway')}</p>
    );
  }

  if (!calendarHasContent(cal)) {
    return (
      <p className={styles.comingSoonNote}>{t('workshop.2026.calendar.empty_progress')}</p>
    );
  }

  const stepLabel = formatCalendarStepLabel(cal);

  return (
    <div className={styles.calendarStatusList}>
      {stepLabel && (
        <CalendarStatusLine label={t('workshop.2026.calendar.current_step')} value={stepLabel} />
      )}
      {cal.step_started_date && (
        <CalendarStatusLine
          label={t('workshop.2026.calendar.started_step')}
          value={formatCalendarDateLabel(cal.step_started_date)}
        />
      )}
      {cal.where_we_are?.trim() && (
        <CalendarStatusLine
          label={t('workshop.2026.calendar.where_we_are')}
          value={cal.where_we_are.trim()}
        />
      )}
      {cal.likely_complete?.trim() && (
        <CalendarStatusLine
          label={t('workshop.2026.calendar.likely_complete')}
          value={formatCalendarDateLabel(cal.likely_complete) || cal.likely_complete.trim()}
        />
      )}
    </div>
  );
};

export default WorkshopCalendarMemberView;
